import React, { useState, useEffect } from 'react';
import { Modal, ModalBody, ModalFooter, ModalHeader, Button, Input, Label, FormFeedback } from 'reactstrap';
import { InputValidation } from 'services';
import * as yup from 'yup';

export function ChangePassword({ visibility, toggle, save }) {

  const populateObject = (invalid, message) => {
    return ({
      invalid,
      message
    })
  }

  const PASSWORD_ERROR = "A senha deve ser a mesma em ambos os campos!";
  const [currentPassword, setCurrentPassword] = useState(populateObject(false, ''));
  const [password, setPassword] = useState(populateObject(false, ''));
  const [newPassword, setNewPassword] = useState("");
  const [repeatedPassword, setRepeatedPassword] = useState("");

  const resetData = ()=> {
    setCurrentPassword("");
    setNewPassword("");
    setPassword("");
    setRepeatedPassword("");
  }

  useEffect(()=> {
    resetData();
  },[visibility])

  useEffect(() => {
    (newPassword === repeatedPassword && newPassword) ?
      setPassword({ value: newPassword }) : setPassword({ value: "" });
  }, [newPassword, repeatedPassword])

  const toggleModal = () => {
    toggle(!visibility);
  }

  const changePasswordSchema = yup.object().shape({
    password:
      yup.string()
        .required(),
    currentPassword:
      yup.string()
        .required()
  });

  const passwordFormData = {
    currentPassword: currentPassword.value,
    password: password.value
  }

  const getValidation = async () => {

    const feedback = await Promise.resolve(
      InputValidation({ schema: changePasswordSchema, formdata: passwordFormData })
    ).then(value => value);
    if(feedback?.id) {
      return feedback.id.forEach((element, index) => {
        getPopulateObject(element, feedback.error[index] );
      });
    }

    return getPopulateObject(feedback?.id);
  }

  const requestNewPassword = ()=> {
   save(passwordFormData);
  }


  const getPopulateObject = (input, value) => {
    const inputs = {
      currentPassword: () => {
        setCurrentPassword(populateObject(true, value))
      },
      password: () => {
        setPassword(populateObject(true, PASSWORD_ERROR));
      }
    }
    return inputs[input] ? inputs[input]() : requestNewPassword();
  }

  return (
    <Modal isOpen={visibility} toggle={toggleModal}>
      <ModalHeader toggle={toggleModal}> Alterar Senha</ModalHeader>
      <ModalBody>
        <Label className={"mt-1"}> Senha atual * </Label>
        <Input
          type="password"
          invalid={currentPassword.invalid}
          value={currentPassword.value}
          id="senha"
          placeholder={'*******'}
          onChange={(e) => {
            setCurrentPassword({ value: e.target.value });
          }} />
        <FormFeedback>
          {currentPassword.message}
        </FormFeedback>
        <Label className={"mt-1"}> Nova senha *</Label>
        <Input
          invalid={password.invalid}
          type="password"
          value={newPassword}
          id="senha"
          placeholder={'*******'}
          onChange={(e) => {
            setNewPassword(e.target.value);
          }} />
        <FormFeedback>
          {password.message}
        </FormFeedback>
        <Label className={"mt-1"}> Confirme a nova senha *</Label>
        <Input
          invalid={password.invalid}
          type="password"
          value={repeatedPassword}
          id="repeatSenha"
          placeholder={'*******'}
          onChange={(e) => {
            setRepeatedPassword(e.target.value);
          }} />
        <FormFeedback>
          {password.message}
        </FormFeedback>
      </ModalBody>
      <ModalFooter>
        <Button color="secundary" onClick={toggleModal}>Cancelar</Button>
        <Button color="primary" onClick={getValidation}>Salvar</Button>{' '}
      </ModalFooter>
    </Modal>
  );
}
